import { render, staticRenderFns } from "./CAxASCxSocialPt3Page.vue?vue&type=template&id=342c358f"
import script from "./CAxASCxSocialPt3Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt3Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports